"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const createIconComponent_1 = require("../createIconComponent");
const pathProps = {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
};
exports.default = createIconComponent_1.default("Share", React.createElement(React.Fragment, null,
    React.createElement("path", Object.assign({}, pathProps, { d: "M8.7 9.8H4.6v13.3h14.8V9.8h-4.1" })),
    React.createElement("path", Object.assign({}, pathProps, { d: "M9 17.4c2.6-5.1 2-10.6 2-10.6H7.6L12.3.9l4.1 5.8-2.9.2c.2 6.1-1.8 11.7-1.8 11.7L9 17.4z" }))));
//# sourceMappingURL=Share.js.map